var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellGoldenDuotone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_555:783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 18.75C21.9951 19.5508 21.3616 20.3125 20.4237 20.3125H1.57538C0.638415 20.3125 0.00444212 19.5508 2.24759e-05 18.75C-0.00212302 18.3556 0.149408 17.9757 0.422835 17.6899C1.37158 16.6763 3.14681 15.1509 3.14681 10.1562C3.14681 6.3623 5.82217 3.3252 9.42958 2.58008V1.5625C9.42958 1.1481 9.59514 0.750671 9.88984 0.457646C10.1845 0.16462 10.5842 0 11.001 0C11.4178 0 11.8175 0.16462 12.1122 0.457646C12.4069 0.750671 12.5724 1.1481 12.5724 1.5625V2.58008C16.1769 3.3252 18.8523 6.3623 18.8523 10.1562C18.8523 15.1514 20.6275 16.6763 21.5762 17.6899C21.8499 17.9756 22.0018 18.3555 22 18.75Z",
    fill: "#FFBD44"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M7.85742 21.875H14.1431C14.1431 22.7038 13.812 23.4987 13.2226 24.0847C12.6332 24.6708 11.8338 25 11.0003 25C10.1667 25 9.36734 24.6708 8.77794 24.0847C8.18854 23.4987 7.85742 22.7038 7.85742 21.875Z",
    fill: "#FFBD44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_555:783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 25,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellGoldenDuotone);
export default __webpack_public_path__ + "static/media/bell-golden-duotone.61577e31.svg";
export { ForwardRef as ReactComponent };